import { mapEmployeeFromDTO } from '@entities/employee/api/mappers'
import { mapPartnerORDFromDTO } from '@entities/partner/api/mappers'
import type { DeepPartial } from '@shared/types'
import type { Channel, ChannelDTO, ChannelSettings, ChannelSettingsDTO } from '../model/types'
import type { CreateChannelArgs, CreateChannelArgsDTO, EditChannelArgs, EditChannelArgsDTO } from './types'

export const mapChannelFromDTO = ({
    id,
    telegram_id,
    username,
    name,
    members_count,
    photo_url,
    created_at,
    updated_at,
    role,
    tg_role,
    timezone,
    language,
    country,
    category,
    settings,
    owner,
    type,
    url,
    visible_for_partners,
    is_fake
}: ChannelDTO): Channel => ({
    id,
    telegramId: telegram_id,
    username,
    name,
    membersCount: members_count,
    photoUrl: photo_url,
    createdAt: new Date(created_at),
    updatedAt: new Date(updated_at),
    role,
    tgRole: tg_role,
    timezone,
    language,
    country,
    category,
    settings: settings && mapChannelSettingsFromDTO(settings),
    owner,
    type,
    url,
    visibleForPartners: visible_for_partners,
    isFake: is_fake
})

export const mapChannelSettingsFromDTO = ({
    general: { silence_mode, post_types, signature, token_link_text, show_signature },
    employees: { employees },
    finance,
    ord
}: ChannelSettingsDTO): ChannelSettings => ({
    general: {
        silenceMode: silence_mode,
        postTypes: post_types,
        signature,
        tokenLinkText: token_link_text,
        showSignature: show_signature
    },
    employees: {
        employees: employees.map(mapEmployeeFromDTO)
    },
    finance,
    ord: ord && mapPartnerORDFromDTO(ord)
})

export const mapChannelSettingsToDTO = (settings?: DeepPartial<ChannelSettings>): DeepPartial<ChannelSettingsDTO> => ({
    general: settings?.general
        ? {
              silence_mode: settings?.general?.silenceMode,
              post_types: settings?.general?.postTypes,
              signature: settings?.general?.signature,
              token_link_text: settings?.general?.tokenLinkText,
              show_signature: settings?.general?.showSignature
          }
        : undefined,
    ord: settings?.ord
        ? {
              organization: settings?.ord.organization,
              type: settings?.ord.type,
              name: settings?.ord.name,
              mobile_phone: settings?.ord.mobilePhone,
              kpp: settings?.ord.kpp,
              inn: settings?.ord.inn,
              fio: settings?.ord.fio,
              ogrn: settings?.ord.ogrn,
              address: settings?.ord.address,
              is_ors: settings?.ord.isORS,
              is_rr: settings?.ord.isRR,
              rs_url: settings?.ord.rsUrl
          }
        : undefined
})

export const mapCreateChannelArgsToDTO = ({
    username,
    language,
    country,
    category,
    timezone,
    partnerId,
    url,
    name,
    type,
    isFake
}: CreateChannelArgs): CreateChannelArgsDTO => ({
    username,
    language,
    country,
    category,
    timezone,
    partner_id: partnerId,
    url,
    name,
    type,
    is_fake: isFake
})

export const mapEditChannelArgsToDTO = ({
    timezone,
    language,
    country,
    category,
    settings,
    url,
    name,
    visibleForPartners,
    type
}: EditChannelArgs['data']): EditChannelArgsDTO['data'] => ({
    timezone,
    language,
    country,
    category,
    settings: mapChannelSettingsToDTO(settings),
    url,
    name,
    visible_for_partners: visibleForPartners,
    type
})
